import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import { createPinia } from 'pinia'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './assets/override-bootstrap.css';
import { useUserStore } from '@/store/modules/user.js'

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
const userStore = useUserStore()

await userStore.GetUser()
app.use(router) 

router.isReady().then(async () => {
  app.mount("#app")
})
